import { motion } from "framer-motion";
import { Mascot } from "@/components/styleguide/Mascot";
import { useAuth } from "./AuthContext";

export function MaintenancePage() {
  const { user, logout } = useAuth();

  // Show first name in the greeting, fall back to "there"
  const firstName = (user?.name?.split(" ")[0] ?? "there").replace(/^\w/, c => c.toUpperCase());

  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center bg-gradient-to-b from-[#FFF7EF] to-[#DCF3EC] px-6 text-center">

      {/* Mascot — gentle float loop */}
      <motion.div
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      >
        <Mascot size={96} mood="happy" animated={false} />
      </motion.div>

      {/* Heading + message */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.45 }}
        className="mt-6 flex w-full max-w-xs flex-col items-center gap-2"
      >
        <h1 className="font-display text-3xl font-black text-foreground">
          Hi {firstName}!
        </h1>
        <p className="font-display text-xl font-black text-foreground">
          We'll be back soon
        </p>
        <p className="mt-1 text-sm font-semibold leading-relaxed text-muted-foreground">
          Bloom is getting a little tune-up right now.
          <br className="hidden sm:block" />
          {" "}Check back in a few minutes!
        </p>
      </motion.div>

      {/* Signed-in label + sign-out */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-10 flex flex-col items-center gap-2"
      >
        <p className="text-xs text-muted-foreground">
          Signed in as{" "}
          <span className="font-semibold text-foreground">
            {user?.name || user?.email}
          </span>
        </p>
        <button
          onClick={logout}
          className="text-xs font-bold text-primary underline underline-offset-2 transition-opacity hover:opacity-70"
        >
          Sign out
        </button>
      </motion.div>

    </div>
  );
}
